const sockets = [
    {
        name: "CASHDRAWER",
        events: ["cashdrawer.opened", "cashdrawer.closed"]
    },
    {
        name: "CONEXFLOW",
        events: ["conexflow.sale.ended"]
    },
    {
        name: "UNIVERSAL TERMINAL",
        events: [
            "universalterminal.display",
            "universalterminal.ticket",
            "universalterminal.signin",
            "universalterminal.keyboard"
        ]
    },
    {
        name: "UNIVERSAL TERMINAL INPUT",
        events: [
            "universalterminal.input.running",
            "universalterminal.input.ended",
            "universalterminal.input.error"
        ]
    },
    {
        name: "UNIVERSAL TERMINAL OUTPUT",
        events: [
            "universalterminal.output.running",
            "universalterminal.output.ended",
            "universalterminal.output.error"
        ]
    },
    {
        name: "UNIVERSAL TERMINAL ABORT LAST",
        events: [
            "universalterminal.abortlast.running",
            "universalterminal.abortlast.ended"
        ]
    },
    {
        name: "PRINTER",
        events: [
            "printer.plugged",
            "printer.unplugged",
            "printer.printing",
            "printer.printed",
            "printer.emptyspooler"
        ]
    },
    {
        name: "MSREADER",
        events: ["msrreader.data"]
    },
    {
        name: "BALANCE",
        events: ["balance.data"]
    },
    {
        name: "RFIDUPOS",
        events: ["rfidupos.data", "rfidupos.open"]
    },
];

export default sockets;
